import React, { Fragment, useCallback, useId, useState } from 'react'
import axios from 'lib/axios'
import Select from 'components/QuestionnaireRequest/AdminNew/components/Select'
import ToggleCheckbox from '../../components/checkbox'

const QuestionnaireType = ({ organizationId, questionnaireType, updateQuestionnaireType, updating, setUpdating }) => {
  const onClose = useCallback(
    async (selectedItem) => {
      setUpdating(true)
      const url = `/super/organizations/${organizationId}/questionnaires/update_questionnaire_type`
      await axios.post(url, {
        questionnaire_type: selectedItem,
      })
      setUpdating(false)
      updateQuestionnaireType(selectedItem)
    },
    [updateQuestionnaireType, setUpdating]
  )

  return (
    <Select
      multiple={false}
      onClose={onClose}
      options={[
        { value: 'manual', label: 'manual only' },
        { value: 'auto', label: 'both manual and auto' },
      ]}
      defaultSelectedItem={questionnaireType || 'manual'}
      disabled={updating}
      atLeastOne={true}
    />
  )
}

const EnableCheckbox = ({ organizationId, enabled, updateEnabled, updating, setUpdating }) => {
  const changeValue = async (enabled) => {
    try {
      setUpdating(true)
      const url = `/super/organizations/${organizationId}/questionnaires/enable`
      await axios.post(url, { enable: enabled ? 1 : 0 })
      updateEnabled(enabled)
    } catch (error) {
      console.log(error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <div className='dome-d-flex dome-align-start'>
      <ToggleCheckbox
        label="enable questionnaires"
        defaultChecked={enabled}
        disabled={updating}
        onChange={(e) => changeValue(e.target.checked)}
      />
    </div>
  )
}

export default function EnableQuestionnaire({
  organizationId,
  enabled,
  updateEnabled,
  questionnaireType,
  updateQuestionnaireType,
}) {
  const [updating, setUpdating] = useState(false)

  return (
    <div className="questionnaire-admin-general-row">
      <EnableCheckbox
        organizationId={organizationId}
        enabled={enabled}
        updateEnabled={updateEnabled}
        updating={updating}
        setUpdating={setUpdating}
      />
      {enabled && (
        <QuestionnaireType
          organizationId={organizationId}
          questionnaireType={questionnaireType}
          updateQuestionnaireType={updateQuestionnaireType}
          updating={updating}
          setUpdating={setUpdating}
        />
      )}
    </div>
  )
}
